<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="contentList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="名称">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="消息标题">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="类型">
        <template slot-scope="scope">
          <span  v-if="scope.row.contentType === 0 ">文字</span>
          <span  v-if="scope.row.contentType === 1">语音</span>
          <span  v-if="scope.row.contentType === 2">图片</span>
          <span  v-if="scope.row.contentType === 3">视频</span>
          <span  v-if="scope.row.contentType === 4">跳转</span>
          <span  v-if="scope.row.contentType === 6">文件</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="内容">
        <template slot-scope="scope">
          <el-popover
              placement="right"
              trigger="hover">
            <span v-if="scope.row.contentType == 0" width="400">
              {{scope.row.content}}
            </span>
            <audio v-if="scope.row.contentType == 1" width="80" :src="scope.row.content" />
            <img v-if="scope.row.contentType == 2" width="400" :src="scope.row.content" />
            <video v-if="scope.row.contentType == 3" width="400" :src="scope.row.content" />
            <img v-if="scope.row.contentType == 4" width="400" :src="JSON.parse(scope.row.content).icon" />
            <span class="upload-list__item-preview" slot="reference">
               <span style=" text-overflow:ellipsis;width: 100px;overflow:hidden;white-space:nowrap;" v-if="scope.row.contentType == 0">
                   {{scope.row.content}}
               </span>
              <audio v-if="scope.row.contentType == 1" width="80" :src="scope.row.content" />
              <img v-if="scope.row.contentType == 2" width="80" :src="scope.row.content" />
              <video v-if="scope.row.contentType == 3" width="80" :src="scope.row.content" />
              <img v-if="scope.row.contentType == 4" width="80" :src="JSON.parse(scope.row.content).icon" />
             </span>
          </el-popover>

        </template>
      </el-table-column>
      <el-table-column align="center" label="是否有选项">
        <template slot-scope="scope">
          <span>{{ scope.row.hasMenu?'是':'否' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"

            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="listQuery.currentPage"
          :page-sizes="[10,20,30, 50]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getContentList,
  removeContent
} from '@/api/demo/helper'
import Video from '@/pages/demo/configuration/templateDialog/video'
import Image from '@/pages/demo/configuration/templateDialog/image'
export default {
  name: 'helperQuestionnaire',
  components: { Image, Video },
  data () {
    return {
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      total: 0,
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      contentList: [],
      listQuery: {
        currentPage: 1,
        pageSize: 20
      },
      listLoading: false
    }
  },
  created () {
    this.getSearch()
  },
  watch: {
    $route (to, from) {
      console.log('to', to)
      if (to.path == '/demo/helper/content' && from.path == '/demo/helper/content/edit') {
        this.getSearch(this.listQuery.currentPage)
      }
    }
  },

  methods: {
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getSearch(val)
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getSearch(val)
    },
    getSearch (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      getContentList(this.listQuery).then(
        res => {
          that.listLoading = true
          that.contentList = res.records
          that.total = Number(res.total)
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    add () {
      this.$router.push({
        path: '/demo/helper/content/edit'
      })
    },
    // 编辑
    editCard (id) {
      this.$router.push({
        path: '/demo/helper/content/edit?id=' + id
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该关键词, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          removeContent(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
